// Dependencies
import React, { Component } from 'react';
import PageTitleComponent from '../../components/page-title/page-title';

// Primereact imports
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// Styling
import './actions.scss';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Redux
import { connect } from 'react-redux';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';

// Utils
import { isMobileOnly } from 'react-device-detect';
import { getPrettyDate } from '../../common/utils/date-utils';


class ActionsPage extends Component {

    constructor(props) {
        super(props);
        this.state = {  
        };
    }

    dateBodyTemplate(rowData, column) {
        if(rowData[column] !== null) {
            return rowData[column] !== undefined ? getPrettyDate(rowData[column].replace('T',' ')) : "";
        }
        else {
            return "";
        }
    }

    render() {
        return (
            <div>
                <PageTitleComponent title={this.props.t('actions.title')} />
                {
                    this.props.registrationRef !== null ?
                    <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                        <div className='col-1'></div>
                        <div className="col-10">                   
                            <div id="data-container" className="card mgt-20">
                            {
                                this.props.payments !== null ? 
                                    <div className="grid">
                                        <div className="col-12">
                                            <DataTable value={this.props.actionLog} paginator className="p-datatable-gridlines" showGridlines rows={10} dataKey="id" responsiveLayout="scroll" emptyMessage={this.props.t("dashboard.no-actions")}>
                                                <Column field="actionDate" header={this.props.t("actions.form.date-header")} body={(data) => this.dateBodyTemplate(data, 'actionDate')} style={{ minWidth: '2rem' }}  />
                                                <Column field="message" header={this.props.t("actions.form.message-header")} style={{ minWidth: '22rem' }}  />
                                            </DataTable>
                                        </div>
                                    </div>
                                    : null
                            }
                            </div>
                        </div>
                        <div className='col-1'></div>
                    </div>
                    : null
                }
            </div>
        );
  }
}

const mapStateToProps = (state) => {
    return {
        actionLog: state.profile.rawActionLog
    } 
};

export default connect(mapStateToProps, undefined)(authenticationChecker(withTranslation(ActionsPage)));